import React from 'react'
import classNames from 'classnames'

import { Pill } from '@/components/pills/Pill'

import {
  FIELD_TYPE_META,
  LOGIC_FIELD_TYPE,
  LOGIC_TYPE_KEY,
  getFieldTypeMeta,
  resolveFieldTypeKey,
  getDisplayTypeMeta,
  resolveDisplayTypeKey,
} from '../helpers'

// A field's UI type shown beside its name as a labeled, color-coded pill.
// Yes/No is a split pill (green "Yes" / red "No") the base Pill can't express,
// so it renders as its own two-segment element.
//
// Pass `typeKey` when the caller has already resolved the field's type (a row
// does, to gate its name options) so the pill and that gating can't disagree.
// Otherwise pass `displayType` — the summary service's authoritative user-facing
// type, e.g. for org field names — or a field's own (fieldType, dataType).
export const FieldTypePill = ({ fieldType, dataType, displayType, typeKey: resolvedTypeKey }) => {
  // Keyed on field_type alone, so a logic field reads as Logic whatever data
  // type it arrived with.
  if (fieldType === LOGIC_FIELD_TYPE) {
    return (
      <Pill
        small
        content={FIELD_TYPE_META[LOGIC_TYPE_KEY].label}
        className="rtn-field-type-pill"
        dataTestId={`field-type-pill-${LOGIC_TYPE_KEY}`}
        {...FIELD_TYPE_META[LOGIC_TYPE_KEY].pillProps}
      />
    )
  }

  const getMeta = () => {
    if (resolvedTypeKey) {
      return FIELD_TYPE_META[resolvedTypeKey]
    }
    if (displayType) {
      return getDisplayTypeMeta(displayType)
    }
    return getFieldTypeMeta(fieldType, dataType)
  }

  const meta = getMeta()
  if (!meta) {
    return null
  }

  const typeKey =
    resolvedTypeKey ||
    (displayType ? resolveDisplayTypeKey(displayType) : resolveFieldTypeKey(fieldType, dataType))

  if (typeKey === 'boolean') {
    return (
      <span className="rtn-field-type-pill--yesno" data-testid="field-type-pill-boolean">
        <span className="rtn-field-type-pill__yes">Yes</span>
        <span className="rtn-field-type-pill__no">No</span>
      </span>
    )
  }

  return (
    <Pill
      small
      content={meta.label}
      className={classNames('rtn-field-type-pill', {
        'rtn-field-type-pill--picklist': typeKey === 'pick_list',
      })}
      dataTestId={`field-type-pill-${typeKey}`}
      {...meta.pillProps}
    />
  )
}
